import { apiClient } from './api';
import { DroneCredentials, EnrolDroneRequest } from '../types/enrolment';

const BASE = '/api/v1/drones';

/**
 * Adding a drone and renewing its credentials (issue #470).
 *
 * Both calls are authenticated with the operator's own id_token, attached by the
 * ApiClient interceptor. The factory key is never involved: it stays in the
 * backend, which is the point — an operator should not be handling the
 * credential that provisions manufacturing.
 */
export const enrolmentService = {
  /** Add a drone and receive its credentials once. */
  async enrol(request: EnrolDroneRequest): Promise<DroneCredentials> {
    return apiClient.post<DroneCredentials>(`${BASE}/enrol`, request);
  },
};
